const store = {
  namespaced: true,
  state: {
    envAgnostic: false,
  },
  mutations: {
    setEnvAgnostic(state, val) {
      state.envAgnostic = val;
    },
  },
};

export default store;
